import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-cuidado-desenvolvimento-infantil`

    return {
        index(data) {
            return repository.post(`${baseUrl}/index`, data)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
    }
}
